import FormSearchIcon from '@images/icon-search-s.svg';

export const HeaderSearchForm = ({ action = '/knowledge/search/' }) => (
  // spa動作させない通常formとする
  (<form action={action}>
    <div className='text-gray-400 focus-within:text-gray-600 relative'>
      <input
        name='q'
        className='placeholder-gray-400 text-gray-900 w-full appearance-none rounded-lg bg-white px-4 py-3 pr-12 focus:outline-none lg:py-1'
        aria-label='search'
      />
      <div className='absolute bottom-0 right-3 top-0 flex items-center'>
        <button type='submit' className='w-5 cursor-pointer'>
          <img
            src={FormSearchIcon.src}
            alt='search'
            width={FormSearchIcon.width}
            height={FormSearchIcon.height}
            loading='lazy'
          />
        </button>
      </div>
    </div>
  </form>)
);

export default HeaderSearchForm;
